import { render, staticRenderFns } from "./DisplayArea.vue?vue&type=template&id=5a7cb2ee&scoped=true&"
import script from "./DisplayArea.vue?vue&type=script&lang=js&"
export * from "./DisplayArea.vue?vue&type=script&lang=js&"
import style0 from "./DisplayArea.vue?vue&type=style&index=0&id=5a7cb2ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7cb2ee",
  null
  
)

export default component.exports